import { render, staticRenderFns } from "./AlibabaOrderDetail.vue?vue&type=template&id=538583bc&scoped=true"
import script from "./AlibabaOrderDetail.vue?vue&type=script&lang=js"
export * from "./AlibabaOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./AlibabaOrderDetail.vue?vue&type=style&index=0&id=538583bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538583bc",
  null
  
)

export default component.exports